module.exports = __webpack_public_path__ + "img/circle_one.c0eb93a2.png";